import client from 'lib/api/client';
const BECON_MALL_BASE_URL = `https://${process.env.REACT_APP_SERVER_BASE_URL}.becon-api.com/mall`;

// 배송정보 가져오기
const get = async (userId: string) => {
  try {
    const delivery = await client.get(
      `${BECON_MALL_BASE_URL}/user-delivery-address/find/user-id/${userId}`,
    );
    return delivery.data;
  } catch (error) {
    return {
      error: error,
      msg: '배송 정보 조회에 문제가 생겼어요 :(',
      items: null,
    };
  }
};

const deliveryService = { get };

export default deliveryService;
